interface getDifferenceInHoursBetweenHoursProps {
  startTime: string
  finalHour: string
}

export function getDifferenceInHoursBetweenHours({ startTime, finalHour }: getDifferenceInHoursBetweenHoursProps) {
  // Converte os horários para minutos desde o início do dia
  const [h1, m1] = startTime.split(':').map(Number)
  const [h2, m2] = finalHour.split(':').map(Number)

  const minutosInicio = h1 * 60 + m1
  const minutosFim = h2 * 60 + m2

  // Se fim for menor que início, significa que passou da meia-noite
  let diferencaMinutos
  if (minutosFim >= minutosInicio) {
    diferencaMinutos = minutosFim - minutosInicio
  } else {
    diferencaMinutos = 24 * 60 - minutosInicio + minutosFim
  }

  const diferencaHoras = diferencaMinutos / 60
  return diferencaHoras
}
